import * as React from 'react';

const EmptyLeads = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={116} height={116} fill="none">
    <path
      fill="#F9F9F9"
      d="M113.329 22.318a35.895 35.895 0 0 1 2.669 13.922v43.5a35.906 35.906 0 0 1-36.247 36.247H7.266a6.843 6.843 0 0 1-5.26-1.993 6.85 6.85 0 0 1-1.993-5.26V36.249A35.906 35.906 0 0 1 36.26.002H79.75a35.906 35.906 0 0 1 33.578 22.316Z"
    />
    <mask
      id="a"
      width={116}
      height={116}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}>
      <path
        fill="#F9F9F9"
        d="M113.329 22.318a35.895 35.895 0 0 1 2.669 13.922v43.5a35.906 35.906 0 0 1-36.247 36.247H7.266a6.843 6.843 0 0 1-5.26-1.993 6.85 6.85 0 0 1-1.993-5.26V36.249A35.906 35.906 0 0 1 36.26.002H79.75a35.906 35.906 0 0 1 33.578 22.316Z"
      />
    </mask>
    <g mask="url(#a)">
      <rect
        width={2.322}
        height={38.307}
        x={56.109}
        y={45.386}
        fill="#D6D5D5"
        rx={1.161}
        transform="rotate(90 56.11 45.386)"
      />
      <g filter="url(#b)">
        <path fill="#fff" d="M18 26h57.033v19.279H18z" />
        <rect
          width={49}
          height={2.41}
          x={22.016}
          y={34.434}
          fill="url(#c)"
          fillOpacity={0.3}
          rx={1.205}
        />
      </g>
      <g filter="url(#d)">
        <path fill="#fff" d="M18 45.68h57.033v19.28H18z" />
        <rect
          width={49}
          height={2.41}
          x={22.016}
          y={54.115}
          fill="url(#e)"
          fillOpacity={0.3}
          rx={1.205}
        />
      </g>
      <g filter="url(#f)">
        <path fill="#fff" d="M18 65.36h57.033v19.28H18z" />
        <rect
          width={49}
          height={2.41}
          x={22.016}
          y={73.795}
          fill="url(#g)"
          fillOpacity={0.3}
          rx={1.205}
        />
      </g>
      <g filter="url(#h)">
        <path fill="#fff" d="M18 85.041h57.033v19.279H18z" />
        <rect
          width={49}
          height={2.41}
          x={22.016}
          y={93.475}
          fill="url(#i)"
          fillOpacity={0.3}
          rx={1.205}
        />
      </g>
      <g filter="url(#j)">
        <path fill="#fff" d="M18 104.721h57.033V124H18z" />
        <rect
          width={49}
          height={2.41}
          x={22.016}
          y={113.156}
          fill="url(#k)"
          fillOpacity={0.3}
          rx={1.205}
        />
      </g>
      <g filter="url(#l)">
        <path fill="#fff" d="M75.434 26h57.033v19.279H75.434z" />
        <rect
          width={49}
          height={2.41}
          x={79.449}
          y={34.434}
          fill="url(#m)"
          fillOpacity={0.3}
          rx={1.205}
        />
      </g>
      <g filter="url(#n)">
        <path fill="#fff" d="M75.434 45.68h57.033v19.28H75.434z" />
        <rect
          width={49}
          height={2.41}
          x={79.449}
          y={54.115}
          fill="url(#o)"
          fillOpacity={0.3}
          rx={1.205}
        />
      </g>
      <g filter="url(#p)">
        <path fill="#fff" d="M75.434 65.36h57.033v19.28H75.434z" />
        <rect
          width={49}
          height={2.41}
          x={79.449}
          y={73.795}
          fill="url(#q)"
          fillOpacity={0.3}
          rx={1.205}
        />
      </g>
      <g filter="url(#r)">
        <path fill="#fff" d="M75.434 85.041h57.033v19.279H75.434z" />
        <rect
          width={49}
          height={2.41}
          x={79.449}
          y={93.475}
          fill="url(#s)"
          fillOpacity={0.3}
          rx={1.205}
        />
      </g>
      <g filter="url(#t)">
        <path fill="#fff" d="M75.434 104.721h57.033V124H75.434z" />
        <rect
          width={49}
          height={2.41}
          x={79.449}
          y={113.156}
          fill="url(#u)"
          fillOpacity={0.3}
          rx={1.205}
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="c"
        x1={4.197}
        x2={74.802}
        y1={34.434}
        y2={34.434}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.01} stopColor="#fff" />
        <stop offset={0.575} stopColor="#BDBDBD" />
        <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="e"
        x1={4.197}
        x2={74.802}
        y1={54.115}
        y2={54.115}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.01} stopColor="#fff" />
        <stop offset={0.575} stopColor="#BDBDBD" />
        <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="g"
        x1={4.197}
        x2={74.802}
        y1={73.795}
        y2={73.795}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.01} stopColor="#fff" />
        <stop offset={0.575} stopColor="#BDBDBD" />
        <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="i"
        x1={4.197}
        x2={74.802}
        y1={93.475}
        y2={93.475}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.01} stopColor="#fff" />
        <stop offset={0.575} stopColor="#BDBDBD" />
        <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="k"
        x1={4.197}
        x2={74.802}
        y1={113.156}
        y2={113.156}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.01} stopColor="#fff" />
        <stop offset={0.575} stopColor="#BDBDBD" />
        <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="m"
        x1={61.631}
        x2={132.236}
        y1={34.434}
        y2={34.434}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.01} stopColor="#fff" />
        <stop offset={0.575} stopColor="#BDBDBD" />
        <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="o"
        x1={61.631}
        x2={132.236}
        y1={54.115}
        y2={54.115}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.01} stopColor="#fff" />
        <stop offset={0.575} stopColor="#BDBDBD" />
        <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="q"
        x1={61.631}
        x2={132.236}
        y1={73.795}
        y2={73.795}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.01} stopColor="#fff" />
        <stop offset={0.575} stopColor="#BDBDBD" />
        <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="s"
        x1={61.631}
        x2={132.236}
        y1={93.475}
        y2={93.475}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.01} stopColor="#fff" />
        <stop offset={0.575} stopColor="#BDBDBD" />
        <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="u"
        x1={61.631}
        x2={132.236}
        y1={113.156}
        y2={113.156}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.01} stopColor="#fff" />
        <stop offset={0.575} stopColor="#BDBDBD" />
        <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
      </linearGradient>
      <filter
        id="b"
        width={57.033}
        height={19.68}
        x={18}
        y={26}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.402} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.176471 0 0 0 0 0.152941 0 0 0 0 0.337255 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4447_40746"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4447_40746"
          result="shape"
        />
      </filter>
      <filter
        id="d"
        width={57.033}
        height={19.68}
        x={18}
        y={45.68}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.402} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.176471 0 0 0 0 0.152941 0 0 0 0 0.337255 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4447_40746"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4447_40746"
          result="shape"
        />
      </filter>
      <filter
        id="f"
        width={57.033}
        height={19.68}
        x={18}
        y={65.361}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.402} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.176471 0 0 0 0 0.152941 0 0 0 0 0.337255 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4447_40746"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4447_40746"
          result="shape"
        />
      </filter>
      <filter
        id="h"
        width={57.033}
        height={19.68}
        x={18}
        y={85.041}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.402} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.176471 0 0 0 0 0.152941 0 0 0 0 0.337255 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4447_40746"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4447_40746"
          result="shape"
        />
      </filter>
      <filter
        id="j"
        width={57.033}
        height={19.68}
        x={18}
        y={104.721}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.402} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.176471 0 0 0 0 0.152941 0 0 0 0 0.337255 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4447_40746"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4447_40746"
          result="shape"
        />
      </filter>
      <filter
        id="l"
        width={57.033}
        height={19.68}
        x={75.434}
        y={26}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.402} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.176471 0 0 0 0 0.152941 0 0 0 0 0.337255 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4447_40746"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4447_40746"
          result="shape"
        />
      </filter>
      <filter
        id="n"
        width={57.033}
        height={19.68}
        x={75.434}
        y={45.68}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.402} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.176471 0 0 0 0 0.152941 0 0 0 0 0.337255 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4447_40746"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4447_40746"
          result="shape"
        />
      </filter>
      <filter
        id="p"
        width={57.033}
        height={19.68}
        x={75.434}
        y={65.361}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.402} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.176471 0 0 0 0 0.152941 0 0 0 0 0.337255 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4447_40746"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4447_40746"
          result="shape"
        />
      </filter>
      <filter
        id="r"
        width={57.033}
        height={19.68}
        x={75.434}
        y={85.041}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.402} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.176471 0 0 0 0 0.152941 0 0 0 0 0.337255 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4447_40746"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4447_40746"
          result="shape"
        />
      </filter>
      <filter
        id="t"
        width={57.033}
        height={19.68}
        x={75.434}
        y={104.721}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.402} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.176471 0 0 0 0 0.152941 0 0 0 0 0.337255 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4447_40746"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4447_40746"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default EmptyLeads;
